import { synapse } from 'services/state'
import { BASE_URL } from 'config'

export const fetchOutputPermissions = async () => {
  return await synapse.fetch(`${BASE_URL}/admin/outputs/permissions`)
}

export const createOutputPermission = async (payload) => {
  await synapse.fetch(
    `${BASE_URL}/admin/outputs/permissions`,
    {
      method: 'POST'
    },
    payload
  )
}

export const removeOutputPermission = async (roleName) => {
  await synapse.fetch(`${BASE_URL}/admin/outputs/permissions/${roleName}`, {
    method: 'DELETE'
  })
}
